module.exports = "/work-site/img/level.91be1484.png";